"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgClockBackwardOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M15 10v6.41l4.29 4.3 1.42-1.42-3.71-3.7V10h-2z" }),
        React.createElement("path", { d: "M16 4A12 12 0 004 16v2.47L1.51 16 .1 17.4l5 5 5-5L8.59 16 6 18.57V16a10 10 0 1110 10 9.92 9.92 0 01-5.45-1.62l-1.1 1.68A12 12 0 1016 4z" })));
}
exports.default = SvgClockBackwardOutline;
//# sourceMappingURL=ClockBackwardOutline.js.map